import 'css-chunksrc/client/scenes/addIdentityProvider/form/azureForm/styles.scss';export default {
  "azureForm": "_azureForm_x97fy_1",
  "group": "_group_x97fy_5",
  "checkboxGroup": "_checkboxGroup_x97fy_13",
  "label": "_label_x97fy_21",
  "checkbox": "_checkbox_x97fy_13"
};